//redux
import { createStore, applyMiddleware } from 'redux';
//logger
import { logger } from 'redux-logger';
//thunks
import thunk from 'redux-thunk';
//rootreducer
import { root } from './rootReducer';

const middleware = [thunk];

export const store = createStore(root, applyMiddleware(...middleware));
